import { ICellRendererParams } from 'ag-grid-community'

import type { ArtifactRow } from '@/pages/company-drawer/artifact/ag-grid-artifact/types'

import { ArtifactActionDropdown } from '@/components/shared/artifact-action-dropdown/artifact-action-dropdown'

export const ArtifactActionCell = ({ data }: ICellRendererParams<ArtifactRow>) => {
  if (!data) return null

  return <ArtifactActionDropdown artifact={data} />
}
